import React, {useEffect, useState} from 'react';
import {useLocation} from "react-router-dom";
import {handleScrollToHash} from "../services/services";
import PhoneSwiper from "../components/Common/PhoneSwiper";
import CustomTabs from "../components/Common/CustomTabs";
import LinkedBank from "../components/SHB/LinkedBank";
import TopUp from "../components/SHB/TopUp";
import Withdraw from "../components/SHB/Withdraw";


const dataLinked = [
	{id: 1, title: 'Thẻ đã đăng kí dịch vụ Internet Banking tại ngân hàng SHB'},
	{id: 2, title: 'Số điện thoại ví phải trùng với số điện thoại đã đăng ký tại ngân hàng SHB'},
	{id: 3, title: 'Số CMND/ CCCD đăng kí với ví phải trùng với số CMND/ CCCD đã đăng kí tại ngân hàng SHB'},
	{id: 4, title: 'Số tài khoản/ số thẻ này đang không liên kết với tài khoản ví GooPay khác'},
]

const dataLinkedBank = [
	{id: 0, title: 'Tại màn hình chính, chọn “Tài khoản” ở góc phải bên dưới màn hình'},
	{id: 1, title: 'Chọn “Quản lý Ví/ Thẻ”'},
	{id: 2, title: 'Chọn “Thêm liên kết ngân hàng”'},
	{id: 3, title: 'Chọn ngân hàng SHB'},
	{id: 4, title: 'Nhập thông tin in trên thẻ SHB của bạn'},
	{id: 5, title: 'Ghi nhớ mã giao dịch tại màn hình “Xác thực”'},
	{id: 6, title: 'Vào ứng dụng SHB SAHA, và chọn “Lấy mã OTP”'},
	{id: 7, title: 'Nhập mã PIN smart OTP, sau đó nhập mã giao dịch vừa ghi nhớ ở Bước số 6'},
	{id: 8, title: '“Sao chép” mã xác thực vừa được tạo'},
	{id: 9, title: 'Quay về ứng dụng Ví GooPay, nhập mã xác thực vừa sao chép'},
	{
		id: 10, title: 'Liên kết ngân hàng thành công. Bạn có thể bắt đầu nạp tiền vào ví GooPay',
	},
];
const dataTopUp = [
	{id: 0, title: 'Tại giao diện chính, chọn “Nạp / Rút tiền”'},
	{id: 1, title: 'Chọn “Nạp tiền vào ví”'},
	{id: 2, title: 'Nhập số tiền cần nạp và nhấn “Tiếp tục”', subtitle: ['Lưu ý: Số tiền nạp tối thiểu 10.000 VNĐ']},
	{id: 3, title: 'Xác nhận thông tin nạp tiền.\n' +
			'Tại Nguồn nạp chọn Ngân hàng SHB'},
	{id: 4, title: 'Nhập mã PIN để xác nhận giao dịch'},
	{id: 5, title: 'Chọn “Xác nhận”'},
	{id: 6, title: 'Ghi nhớ mã giao dịch tại màn hình “Xác thực”'},
	{id: 7, title: 'Vào ứng dụng SHB SAHA, và chọn “Lấy mã OTP”'},
	{id: 8, title: 'Nhập mã PIN smart OTP của ứng dụng SHB SAHA, sau đó nhập mã giao dịch vừa ghi nhớ ở Bước số 7'},
	{id: 9, title: 'Sao chép mã xác thực vừa được tạo'},
	{
		id: 10, title: 'Quay về ứng dụng Ví GooPay, nhập mã xác thực vừa sao chép',
	},
	{
		id: 11, title: 'Nạp tiền thành công. Bạn có thể quay về trang chủ để kiểm tra số dư Ví.',
	},
];

const dataWithdraw = [
	{
		id: 0,
		title: 'Tại giao diện chính, chọn “Nạp / Rút tiền”',
	},
	{
		id: 1,
		title: 'Chọn “ Rút tiền về ngân hàng”',
	},
	{id: 2, title: 'Nhập số tiền cần rút và “Tiếp tục”', subtitle:['Lưu ý: Số tiền rút tối thiểu 50.000 VNĐ']},
	{
		id: 3, title: 'Chọn  “Ngân hàng nhận tiền” là SHB',
	},
	{id: 4, title: 'Nhập mã PIN'},
	{id: 5, title: 'Chọn “Xác nhận”'},
	{id: 6, title: 'Rút tiền thành công'},
];

const LinkGuideSHB = () => {
	const [activeTab, setActiveTab] = useState(0);
	const [step, setStep] = useState(0);
	const location = useLocation();
	const {hash} = location || {};
	
	useEffect(() => {
		handleScrollToHash({sectionId: hash.substring(1)});
	}, [hash]);
	
	const tabs = [
		{label: 'Liên kết ngân hàng', quantity: 11, content: <LinkedBank isSHB data={dataLinkedBank} setStep={setStep} step={step}/>},
		{label: 'Nạp tiền vào Ví', quantity: 12, content: <TopUp isSHB data={dataTopUp} setStep={setStep} step={step}/>},
		{label: 'Rút tiền về ngân hàng', quantity: 7, content: <Withdraw isSHB data={dataWithdraw} setStep={setStep} step={step}/>},
	];
	
	const onClickTab = (index) => {
		setActiveTab(index);
	}
	
	return (
		<div className="mx-auto w-full animate-fadeIn text-sm space-y-5 md:space-y-10 pt-10">
			<div className='flex justify-center items-center text-center space-x-4 text-sm md:text-[17px] font-bold'>
				<div>
					Hướng dẫn Liên kết/ Nạp / Rút tiền với tài khoản Ngân hàng
				</div>
				<img src='/img/SHB.svg' alt='shb'/>
			</div>
			
			<div className="mx-auto w-fit">
				<CustomTabs
					data={tabs}
					onClickTab={onClickTab}
					activeTab={activeTab}
				/>
				<div
					className='flex flex-wrap md:font-normal justify-center items-center md:justify-start md: md:items-start font-bold md:space-x-14'>
					<div
						className="bg-transparent rounded-b-lg pb-4 md:pb-0 mx-auto"
						role="tabpanel"
						id={`tabpanel-${activeTab}`}
						aria-labelledby={`tab-${activeTab}`}
					>
						<PhoneSwiper
							path={'guild-step/linked-step-shb'}
							activeTab={activeTab}
							step={step}
							setStep={setStep}
							setActiveTab={setActiveTab}
							quantity={tabs[activeTab]?.quantity}
						/>
					</div>
					{tabs[activeTab].content}
				</div>
				<div className='text-sm max-w-[800px] mt-4'>
					<div className='space-y-2'>
						<div className='text-left'>
							Lưu ý: Để liên kết thành công, thẻ phải đáp ứng các điều kiện dưới đây
						</div>
						<div className="text-left">
							{dataLinked.map((item, index) => (
								<div key={index}
								     className='flex items-start space-x-2 mb-2'>
									<div className='w-1 h-1 min-w-1 min-h-1 rounded-full bg-black mt-2'></div>
									<div>{item.title}</div>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
			
			<img className="z-[-1] mt-[-100px] md:mt-[-200px] w-full" src="/img/bg-city.png" alt="bg-city"/>
		</div>
	)
};

export default LinkGuideSHB;
